module.exports = __webpack_public_path__ + "img/cangkubtns_sel.818218c2.png";